// Reference: https://kentcdodds.com/blog/authentication-in-react-applications

import { LoadingSpinner } from 'app/components/ui/LoadingSpinner'
import { useAuth } from 'app/contexts/AuthenticationProvider'
import React, { Suspense } from 'react'

const PrivateAppRouter = React.lazy(() => import('./PrivateAppRouter'))
const PublicAppRouter = React.lazy(() => import('./PublicAppRouter'))

export const AppRouter = (): JSX.Element => {
  const { user } = useAuth()

  return user ? (
    <Suspense fallback={<LoadingSpinner isFullScreen />}>
      <PrivateAppRouter user={user}></PrivateAppRouter>
    </Suspense>
  ) : (
    <Suspense fallback={<LoadingSpinner isFullScreen />}>
      <PublicAppRouter></PublicAppRouter>
    </Suspense>
  )
}
